import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "9.99984",
      cy: "10.4993",
      r: "5.83333",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.3332 5.49935L13.1062 4.59137C12.8274 3.47635 12.688 2.91884 12.2915 2.57438C12.2476 2.53629 12.2018 2.50052 12.1542 2.46722C11.7238 2.16602 11.1492 2.16602 9.99984 2.16602C8.8505 2.16602 8.27583 2.16602 7.84547 2.46722C7.79788 2.50052 7.75207 2.53629 7.70822 2.57438C7.31163 2.91884 7.17225 3.47635 6.8935 4.59137L6.6665 5.49935",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.6665 15.5L6.8935 16.408C7.17225 17.523 7.31163 18.0805 7.70822 18.425C7.75207 18.4631 7.79788 18.4988 7.84547 18.5321C8.27583 18.8333 8.8505 18.8333 9.99984 18.8333C11.1492 18.8333 11.7238 18.8333 12.1542 18.5321C12.2018 18.4988 12.2476 18.4631 12.2915 18.425C12.688 18.0805 12.8274 17.523 13.1062 16.408L13.3332 15.5",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 8.83203V10.5029L10.8333 11.332",
      stroke: "white",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }